import { IMenuElement } from "@unlimint/admin-ui-kit"

const isCurrentPathEqualMenu = (
  item: IMenuElement,
  path?: string,
  childPath?: string
) => {
  if (!path) return false
  if (!childPath) return item.to === `/${path}`

  return item?.to === `/${path}/${childPath}`
}

export const prepareMenuConfig = (
  config: IMenuElement[],
  path?: string,
  childPath?: string
) =>
  config.reduce((acc, item) => {
    const isHomePage = item?.to === "/" && !path
    const isCurrentItemSelected =
      isHomePage || isCurrentPathEqualMenu(item, path)

    if (item.childItems) {
      const childList = item.childItems.reduce((childAcc, child) => {
        const isChildSelected = isCurrentPathEqualMenu(child, path, childPath)

        childAcc.push({
          ...child,
          isSelected: isChildSelected,
        })

        return childAcc
      }, [])

      const hasSelectedChildren =
        childList?.length &&
        childList?.find((childListItem) => childListItem.isSelected)

      if (!hasSelectedChildren && isCurrentItemSelected) {
        childList[0].isSelected = true
      }

      item.childItems = childList
    }

    acc.push({
      ...item,
      isSelected: isCurrentItemSelected,
    })
    return acc
  }, [])
